import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ title, description, canonicalPath, lang = 'sl', alternateUrl, jsonLd }) => {
  const baseUrl = 'https://general-ledger.eu';
  const canonical = `${baseUrl}${canonicalPath}`;
  
  // Determine alternate language
  const alternateLang = lang === 'sl' ? 'en' : 'sl';
  const alternateHref = alternateUrl ? `${baseUrl}${alternateUrl}` : null;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      
      {/* Hreflang tags - current language */}
      <link rel="alternate" hrefLang={lang} href={canonical} />
      
      {/* Hreflang tags - alternate language */}
      {alternateHref && (
        <link rel="alternate" hrefLang={alternateLang} href={alternateHref} />
      )}
      
      {/* x-default only for main pages */}
      {(canonicalPath === '/' || canonicalPath === '/en') && (
        <link rel="alternate" hrefLang="x-default" href={`${baseUrl}/`} />
      )}
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="GENERAL LEDGER d.o.o." />
      <meta property="og:locale" content={lang === 'sl' ? 'sl_SI' : 'en_US'} />
      <meta property="og:image" content={`${baseUrl}/images/exterior.webp`} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEOHead;
